/**
 * Shared scoring types for the Climate Risk Module.
 * See docs/superpowers/specs and climate-risk-module-functional-spec.md (project root).
 */

/** A score on the platform's 1 (lowest risk) – 4 (highest risk) scale. */
export type Score = 1 | 2 | 3 | 4;

/**
 * A hazard indicator score. 0 is a valid value distinct from 1 — it means
 * "no risk" (per the original methodology doc §2.3.1), not "unscored".
 */
export type HazardScore = 0 | Score;

export type HazardType =
  | "heat_stress"
  | "changing_precipitation"
  | "water_stress"
  | "drought"
  | "floods"
  | "landslide";

export type ClimateScenario = "SSP2-4.5" | "SSP5-8.5";

export type TimeHorizon = "historical" | "2030" | "2050";

/** East Africa's two fixed precipitation seasons (KEN/UGA/TZA/RWA/BDI). */
export type EacPrecipitationSeason = "MAM" | "OND";

/** A site's main rainy season: its single wettest 3-month window, used where
 * a site is scored on that season only (Malawi, team decision 28 Oct 2026).
 * See shared/precipitation-seasons.ts for labels. */
export type MainRainySeason = "DJF" | "JFM" | "FMA";

/** A precipitation row's season label: MAM + OND (two rows per site), or one
 * main rainy season (one row per site). Never combined into one score. */
export type PrecipitationSeason = EacPrecipitationSeason | MainRainySeason;

/** All 6 hazards, in the order used throughout the UI (matches functional spec §4). */
export const HAZARD_TYPES: readonly HazardType[] = [
  "heat_stress",
  "changing_precipitation",
  "water_stress",
  "drought",
  "floods",
  "landslide",
];
